import('./bootstrap.tsx');
